import { PaymentsTranslations } from "./paymentTranslations.types";
import { getCgvLink } from "@/service/legalLinks/legalLinksService";

const cgvUrl = getCgvLink();

const paymentUkTranslations: PaymentsTranslations = {
    "paymentsPage": {
        "title": "Payment",
        "paymentMyAccount": "My account",
        "paymentChooseMethod": "Choose payment method",
        "paymentByCreditCard": "Pay by card",
        "paymentByBancontact": "Pay by Bancontact",
        "proceedToPay": "Proceed to payment",
        "paymentByIdeal": "Pay by iDeal",
        "paymentCreditCardPaymentCondition1Desc1": "With a Flex rate, the deposit is",
        "paymentCreditCardPaymentCondition1Desc2": ", which corresponds to",
        "paymentCreditCardPaymentCondition1Desc3": "of the total travel cost of your ski vacation.",
        "paymentCreditCardPaymentCondition1Desc4": "The remaining amount of",
        "paymentCreditCardPaymentCondition1Desc5": ", will be automatically debited on",
        "paymentCreditCardPaymentCondition1Notice1": "30% deposit required at the point of booking, free modification until",
        "paymentCreditCardPaymentCondition1Notice12": "(booking fees and insurance not included)",
        "paymentCreditCardPaymentCondition1Notice22": ". Modifications of extras not including accommodations according",
        "paymentCreditCardPaymentCondition1Notice23": "terms and conditions.",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit1": "With a Flex rate, the deposit is",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit2": ", which corresponds to",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit3": "of the total travel cost of your ski vacation.",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit4": "The remaining amount of",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit5": ", will be automatically debited on",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit1": "30% deposit required at the point of booking, free modification until",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit2": "(booking fees and insurance not included). Modifications of extras not including accommodations according",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit3": "terms and conditions.",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit1": "With a Flex rate, the deposit is",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit2": ", which corresponds to 100% of the total travel cost of your ski vacation.",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit3": "Free cancelation and modification until",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit4": "(booking fees and insurance not included). Modifications of extras not including accommodations according",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit5": "terms and conditions.",
        "paymentCreditCardPaymentCondition1NoticePvAfterDeposit1": "Full payment at point of booking.",
        "paymentCreditCardPaymentCondition2Desc1": "You have chosen a Fixed offer. Today we are debiting",
        "paymentCreditCardPaymentCondition2Desc2": ", which corresponds to 100% of the total travel cost of your ski vacation.",
        "paymentCreditCardPaymentCondition2Desc3": "Non refundable. Modifications of extras not including accommodations according",
        "paymentCreditCardPaymentCondition2Desc4": "terms and conditions.",
        "paymentCreditCardPaymentCondition2Notice1": "Full payment at point of booking. Non refundable.",
        "paymentErrorPopupTitle": "Payment declined",
        "paymentErrorPopupText": "Sorry, but your payment has been declined. Please try again or contact us on",
        "paymentErrorPopupButton": "OK",
        "paymentStatusCheckPayment": "Check payment",
        "paymentStatusConfirmPayment": "Confirm payment",
        "paymentStatusCheckAvailability": "Check availability",
        "loadingPrice": "Loading price...",
        "accommodationUnavailable": "Accommodation unavailable",
        // Train-only
        "trainOnlyConditionsDescription": `Cancellation and modification according to the <a href="${cgvUrl}" target="_blank" rel="noopener">terms and conditions</a>.`,


        "paymentCreditCardPaymentCondition1DescPvAfterDeposit6": "",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit7": "",
        "paymentCreditCardPaymentCondition1Notice24": "",
        "paymentCreditCardPaymentCondition1Notice25": "",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit4": "Notice text 4", // Add appropriate text
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit5": "Notice text 5", // Add appropriate text
        "paymentCreditCardPaymentCondition2Desc5": "Description text 5", // Add appropriate text
        "paymentCreditCardPaymentCondition2Desc6": "Description text 6", // Add appropriate text
        "paymentConditionsDescriptionFlex": `The payments detailed above will be automatically debited on the dates indicated and any changes or modifications can only be actioned in line with <a href="${cgvUrl}" target="_blank">terms and conditions.</a> <br> 
        Cancellation terms are detailed in Article 5.3; do note that if you cancel your booking, you remain liable to make additional payments to cover the cancellation charges.`,
        "paymentConditionsDescriptionFixe": "Full payment at point of booking. Non refundable.",
        "fixeProduct": "Fixed",
        "flexProduct": "Flex",
        "paymentAmountDescriptionFlex": "The balance for each payment will be automatically debited on the dates shown above.",
        "paymentAmountDescriptionFixe": "You have chosen a Fixed offer. Today we are debiting <b>deposit_amount</b>, which corresponds to 100% of the total travel cost of your ski vacation.",
        "paymentNotReady": "Payment not ready",
        "checkParticipants": "Check participant information",
        "checkFlight": "Check flight availability",
        "checkAccommodationStock": "Check accommodation stock",
        "accommodationNoLongerAvailable": "This accommodation is no longer available",
        "accommodationUnavailableModalTitle": "This accommodation is no longer available.",
        "accommodationUnavailableModalText1": "Unfortunately, the accommodation you selected is no longer available.",
        "accommodationUnavailableModalText2": "We invite you to select an alternative accommodation from our offerings.",
        "accommodationUnavailableModalClose": "Close",
        "accommodationUnavailableModalCta": "See other accommodations",
        "fillParticipantsDetailsMessage": "Please provide the full names and dates of birth of all participants to proceed to payment or save your quote.",
        "paymentModeTitle": "Choose your payment option",
        "payNowPartial": "Pay deposit now",
        "payNowFull": "Pay full amount now",
        "payLater": "scheduled_amount on slot_date",
        "payInitialDepositNow": "Pay initial deposit now {amount}",
        "scheduledSecondDepositLine": "2nd deposit of {amount} due on {date}",
        "scheduledBalanceLine": "Balance of {amount} due on {date}",
        "scheduledFurtherPaymentLine": "Further payment of {amount} due on {date}",
        "remainingToPayAdyen": "Remaining to pay: <b>{amount}</b>"
    },
    "systempayError": {
        "0": "",
        "2": "",
        "3": "",
        "4": "",
        "5": "Your payment was not approved by your bank.\n\nWe recommend contacting your bank for more information or trying another payment method.\n\nThank you for your understanding.",
        "7": "",
        "8": "",
        "12": "",
        "13": "",
        "14": "",
        "15": "",
        "17": "",
        "19": "",
        "20": "",
        "24": "",
        "25": "",
        "26": "",
        "27": "",
        "28": "",
        "29": "",
        "30": "",
        "31": "",
        "33": "",
        "34": "",
        "38": "",
        "41": "",
        "43": "",
        "46": "",
        "51": "Your payment could not be completed due to insufficient funds or because your credit limit has been exceeded.\n\nWe invite you to check your account or contact your bank for more information. You may also choose another payment method.\n\nThank you for your understanding.",
        "54": "",
        "55": "",
        "56": "",
        "57": "Your payment could not be processed because this type of transaction is not allowed for your card.\n\nWe recommend contacting your bank for more information or using another payment method.\n\nThank you for your understanding.",
        "58": "",
        "59": "We are sorry, but your payment could not be validated due to suspected fraud. For security reasons, we have suspended this transaction.\n\nPlease verify your payment information and try again. If the issue persists, we recommend contacting our customer service or using another payment method.\n\nThank you for your understanding.",
        "60": "",
        "61": "",
        "63": "",
        "65": "",
        "68": "",
        "75": "",
        "76": "",
        "78": "",
        "80": "",
        "81": "",
        "82": "",
        "83": "",
        "84": "",
        "86": "",
        "88": "",
        "90": "",
        "91": "",
        "94": "",
        "96": "",
        "97": "",
        "98": "",
        "99": ""
    },
    "participant": {
        title: "Participants details",
        addParticipant: "Add participant",
        participant: "Participant",
        removeParticipantModalTitle: "Remove participant",
        removeParticipantModalBody: "Do you really want to remove the participant",
        removeParticipantModalDismiss: "Cancel",
        removeParticipantModalValidate: "Remove",
        yearsOld: "years old",
        checkNameTitle: "CHECK YOUR NAMES",
        checkNameContent: "Each name has to appear exactly like in your identity document.",
        checkNameContentLikeInPassport: "Each name has to appear exactly like in the passport.",
        placeholderDataWarning: "Don't forget to fill in the first names, last names, and dates of birth of each participant.",
        male: "Male",
        female: "Female",
        firstName: "First Name",
        lastName: "Last Name",
        dayShort: "DD",
        monthShort: "MM",
        yearShort: "YYYY",
        dateOfBirth: "Date of birth",
        submit: "Save",
        delete: "Remove participant",
        childTrainFreeMessage: "Your child under 3 years old travels free on your couchette."
    },
    "quote": {
        "saveYourQuote": "Save your search",
        "devisDesc1": "By saving your search, you can <b>find it in your personal space under 'My Customer Account'</b> to proceed with payment whenever you wish. <br> <br> <b>Note:</b> Check the availability of your stay at the time of booking.",
        "devisDesc4": "",
        "devisDesc5": "Check the availability of your stay at the time of booking.",
        "save": "Save",
        "makeQuote": "Your trip search"
    }
}

export default paymentUkTranslations;